module.exports = __webpack_public_path__ + "static/media/2-turtle-wanted.1d49969b.svg";